<template>
  <v-navigation-drawer v-model="drawer" @input="updateDrawerState" fixed right temporary id="user-drawer">
    <div class="full-height d-flex align-content-space-between flex-column">
      <v-list nav dense>
        <div v-if="dealerName" class="dealer-name">{{ dealerName }}</div>
        <div v-if="user" class="drawer-user-info" data-cy="drawer-user">
          <user-info-button
            :user-name="cognitoUserName"
            :user-email="user.login"
            content-color="#333333"
            :name-color="primaryColor"
            background-color="white" />
        </div>

        <v-divider class="my-2" />

        <v-list-item
          data-cy="drawer-editAccount"
          v-if="permissions && permissions.dealerProfile.canSee && !userHasNoDealer"
          to="/profile">
          <v-list-item-icon>
            <v-icon dense color="primary">fa-light fa-pen-to-square</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.edit-account') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{name: 'Solicitudes'}"
          data-cy="drawer-logout"
          v-if="permissions && permissions.requests.canSee">
          <v-list-item-icon>
            <v-icon dense color="primary">fa-light fa-message-lines</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.requests') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{name: 'DataImport'}"
          data-cy="drawer-logout"
          v-if="permissions && permissions.imports.canSee">
          <v-list-item-icon>
            <v-icon class="icon-mapit" color="primary">&</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.data-import') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'UsersManager'}" v-if="canSeeCognitoUserManagement && !userHasNoDealer">
          <v-list-item-icon>
            <v-icon dense color="primary">fa-light fa-users-gear</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.users-manager') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'StocksManager'}" v-if="permissions && permissions.stocks.canSee && !userHasNoDealer">
          <v-list-item-icon>
            <v-icon dense color="primary">fa-light fa-hand-holding-box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.stocks') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{name: 'Warranties'}"
          v-if="permissions && permissions.userCredentials.canSee && !userHasNoDealer">
          <v-list-item-icon>
            <img src="/images/warranties/warranties-icon.svg" alt="warranties" class="warranties-icon" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.warranties') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.prevent="exit" data-cy="drawer-logout" v-if="user">
          <v-list-item-icon>
            <v-icon dense color="primary">fa-light fa-arrow-right-from-bracket</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.sign-out') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <version class="mt-auto ma-2" />
    </div>
  </v-navigation-drawer>
</template>

<script>
import {mapState} from 'vuex'

import UserInfoButton from '@/components/UserInfoButton'
import Version from '@/components/Version'
import {authAdapter} from '@/services/auth-adapter'

export default {
  name: 'DrawerUserMenu',
  components: {Version, UserInfoButton},
  data() {
    return {}
  },
  computed: {
    ...mapState(['permissions']),
    canSeeDealerProfile() {
      return this.permissions?.dealerProfile?.canSee || false
    },
    canSeeRequests() {
      return this.permissions?.requests?.canSee || false
    },
    canSeeImports() {
      return this.permissions?.imports?.canSee || false
    },
    canSeeUserCredentials() {
      return this.permissions?.userCredentials?.canSee || false
    },
    canSeeCognitoUserManagement() {
      return this.permissions?.cognitoUserManagement?.canSee || false
    },
    canSeeStocks() {
      return this.permissions?.stocks?.canSee || false
    },
    userHasNoDealer() {
      return this.$store.getters.userHasNoDealer
    },
    drawer: {
      get() {
        return this.$store.getters.getUserDrawerState
      },
      set(val) {
        this.$store.dispatch('setUserDrawerState', val)
      },
    },
    primaryColor() {
      return getComputedStyle(document.documentElement).getPropertyValue('--v-primary-base').trim()
    },
    dealerName() {
      return this.group && this.group.name ? this.group.name : ''
    },
    cognitoUserName() {
      return this.$store.getters.getCognitoUserName
    },
    group() {
      return this.$store.getters.getGroup
    },
    user() {
      return this.$store.getters.getUser
    },
    allowImport() {
      return this.$store.getters.isImportUser
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    isDealerAdmin() {
      return this.$store.getters.isDealerAdmin
    },
  },
  methods: {
    updateDrawerState(state) {
      this.$store.dispatch('setUserDrawerState', state)
    },
    closeUserDrawer() {
      this.$store.dispatch('setUserDrawerState', !this.$store.getters.getUserDrawerState)
    },
    async exit() {
      try {
        await authAdapter.signOut()
        this.$store.dispatch('resetStore')
        this.$store.dispatch('setUserDrawerState', false)
        this.$store.dispatch('logout')
        this.$router.push({name: 'Login'})
      } catch (error) {
        console.error('Sign out error:', error)
      }
    },
  },
}
</script>

<style lang="less">
#user-drawer {
  background-color: white;
  * {
    text-decoration: none !important;
  }
  i {
    width: 28px;
    height: 28px;
  }
  .warranties-icon {
    width: 24px;
    height: 24px;
    filter: invert(14%) sepia(89%) saturate(5765%) hue-rotate(350deg) brightness(89%) contrast(93%);
  }
  .drawer-user-info {
    padding: 8px;
  }
  .dealer-name {
    font-size: 14px;
    font-family: 'ProximaNovaSemibold', sans-serif;
    font-weight: 600;
    color: #333333;
    padding-left: 31px;
  }
  #user-avatar {
    width: auto !important;
    min-width: 0 !important;
    margin-right: 15px;
  }
  .v-subheader {
    color: #333333 !important;
  }
  .v-list--nav {
    .v-list-item {
      padding: 0 6px;
    }
  }
  .v-list-item__avatar {
    margin-right: 5px;
    margin-left: 5px;
    margin-bottom: 8px;
    margin-top: 8px;
  }
  .v-list-item__icon {
    margin-right: 10px;
    margin-left: 10px;
  }
  .v-list-item__title {
    font-size: 16px;
    line-height: 1.5rem;
    color: #333333 !important;
    &.bold-title {
      font-family: 'ProximaNovaSemibold', sans-serif !important;
    }
  }
  .v-list-item__content {
    padding: 0;
    .v-list-item__title {
      color: black;
      font-family: 'ProximaNovaRegular', sans-serif;
    }
    .v-list-item__subtitle {
      font-size: 12px;
      color: #555555 !important;
      font-family: 'ProximaNovaRegular', sans-serif;
    }
  }
  .v-divider {
    background-color: rgba(255, 255, 255, 0.4);
  }
}
</style>
